export const NOTIFICATIONS = {
  FETCH_SUMMARY: 'NOTIFICATIONS/FETCH_SUMMARY',
};
